import * as React from "react";
import { EnergyData, TimePeriod } from "../types";
import { getChartOptions, makeChartData } from "../utils";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartOptions,
    ChartData,
    TimeScale
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import 'chartjs-adapter-luxon';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    TimeScale
);

const loadingComponent = () => <div className="h-40 w-full rounded flex items-center justify-center gap-2">
    <span className="loading loading-spinner loading-md text-gray-400"></span>
</div>;

const DataChart: React.FC<{ energyData: EnergyData | null, loading: boolean }> = ({ energyData, loading }) => {
    if (loading) {
        return loadingComponent();
    } else if (!energyData) {
        return <div className="h-40 w-full rounded flex items-center justify-center gap-2">
            <span className="text-white font-semibold">No data available</span>
        </div>;
    }

    const options = getChartOptions('oklch(37.9% 0.146 265.522)');
    const { bessChargingData, bessDischargingData, solarData, consumptionData } = makeChartData(energyData);
    const chartData = {
        labels: energyData.time_range.labels,
        datasets: [
            {
                label: 'BESS Charging',
                data: bessChargingData,
                backgroundColor: '#ae6cffff',
            },
            {
                label: 'BESS Discharging',
                data: bessDischargingData,
                backgroundColor: '#ef784dff',
            },
            {
                label: 'Solar PV',
                data: solarData,
                backgroundColor: '#ffd15cff',
            },
            {
                label: 'Consumption',
                data: consumptionData,
                backgroundColor: '#6cdcdc',
            },
        ],
    }

    if (!chartData.labels || !chartData.datasets) {
        return loadingComponent();
    }

    return <Bar options={options} data={chartData} />;
};

export default DataChart;